import { render, staticRenderFns } from "./deleteConnection.vue?vue&type=template&id=30deef93&scoped=true"
import script from "./deleteConnection.vue?vue&type=script&lang=js"
export * from "./deleteConnection.vue?vue&type=script&lang=js"
import style0 from "./deleteConnection.vue?vue&type=style&index=0&id=30deef93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30deef93",
  null
  
)

export default component.exports